import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  Autocomplete,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../Component/Common/ToolBox/ToolBoxV1";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import CloseIcon from "@mui/icons-material/Close";
import "../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  LoadingList_LoadingListAttributes_GETROW,
  TruckDetailsGetrow,
  TruckDriverDetailsGetrow,
  WMLDLSTA_TruckDriver_Update,
  WMLDLSTATruck_Getrow,
} from "../../Server/ApiV2";
import "../LoadingList/processComponent/UpdatedTruck.css";
import { useSelector } from "react-redux";
import { vRdxUserInfo } from "../../Redux/roStore";
// import { RoLoadingLists } from "../../../Redux/roStore";
// import { Set_LoadingList_HeadObject_Set } from "../SliceLoadingList";
const UpdatedTruck = ({
  xOpen = false,
  CloseUpdatedTruckModal,
  xTitle = "Updated Truck",
  selectedData = {},
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const vMediaQuery = useMediaQuery("(max-width: 1024px)");

  const [truckData, setTruckData] = useState([]);

  const formData = {
    truck: "",
    driver: "",
    driverName: "",
    CBM: "",
  };

  const [masterData, setMasterData] = useState(formData);

  const handleUpdate = async () => {
    // const { HeadObject } = RoLoadingLists();
    if (
      masterData?.truck === "" ||
      masterData?.truck === null ||
      masterData?.truck === undefined
    ) {
      fAlertToast("FAILED", "truck should not be empty");
      return;
    } else if (
      masterData?.driver === "" ||
      masterData?.driver === null ||
      masterData?.driver === undefined
    ) {
      fAlertToast("FAILED", "Driver name should not be empty");
      return;
    }
    const obj = {
      VocTyp: selectedData?.DocTyp,
      VocNo: selectedData?.DocNo,
      Truck: masterData?.truck,
      Driver: masterData?.driver,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const UpdateRes = await WMLDLSTA_TruckDriver_Update(FinalObj);

    if (UpdateRes?.status === 200) {
      fAlertToast("SUCCESS", "Updated Successfully");
      setMasterData(formData);
      CloseUpdatedTruckModal();
    }
  };

  const fLoadTruck = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();
    var vDCRequestObj = {
      userCode: vRdxUserInfoObj.UserID,
      userGroupCode: vRdxUserInfoObj.UserGroupCode,
    };
    const iAttributes = await LoadingList_LoadingListAttributes_GETROW(
      vDCRequestObj
    );
    if (iAttributes?.status === 200) {
      
      setTruckData(iAttributes?.data?.ResultSet?.Truck);
      let resp = iAttributes?.data?.ResultSet?.Truck.find((obj)=> obj.UId == selectedData.TruckCode);
      if (resp) {
        setMasterData({
          truck: resp.UId,
          driver: resp.Driver,
          driverName: resp.DriverName,
          CBM: resp.CBM,
        });
      } else {
        setMasterData(formData);
      }
    }
  };

  useEffect(() => {
    if (xOpen) {
      fLoadTruck();
    }
  }, [xOpen]);
  return (
    <div>
      <Modal
        open={xOpen}
        onClose={CloseUpdatedTruckModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box >
          <div className="p-2">
            <div
              style={{
                height: "auto",
                overFlowY: "auto",
                maxHeight: "90vh",
                flexGrow: 1, overflow: "auto",
                width: isMobile ? "95%" : "25%",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "var(--commonText)",
                border: "1px solid var(--primary)",
                boxShadow: "24px 24px 48px rgba(80, 40, 40, 0.1)",
                borderRadius: "10px",
              }}
            >
              
              <GCTitleSticky title={xTitle} onClose={CloseUpdatedTruckModal} />
              <div style={{ height: isMobile ? "50%": "auto",overflowX: "auto" }}>
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ padding: 4,  height: isMobile ? "50%": "auto", }}
                >
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography>Voucher Type</Typography>
                    <CmpTextFieldV1
                      xLabelText=""
                      xValue={selectedData?.DocTyp}
                      xType={"text"} // text/number/password
                      xName={"VocType"}
                      xReadOnly={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography>Voucher No</Typography>
                    <CmpTextFieldV1
                      xLabelText=""
                      xValue={selectedData?.DocNo}
                      xType={"text"} // text/number/password
                      xName={"VocNo"}
                      xReadOnly={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography>Truck ID</Typography>
                    <Autocomplete
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          padding: "3px !important",
                        },
                        "& .MuiInputBase-input": {
                          padding: "5.5px 10px !important",
                        },
                      }}
                      freeSolo
                      id="free-solo-2-demo"
                      disableClearable
                      options={truckData}
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option || ""
                          : option?.Name1 || ""
                      }
                      value={
                        truckData?.find(
                          (truck) => truck?.UId === masterData?.truck
                        ) || null
                      }
                      // value={masterData?.truck}
                      onChange={(event, newValue) => {
                        let vTruckObj = truckData.find((obj) => {
                          return obj.UId === newValue.UId;
                        });
                        setMasterData((prevV) => ({
                          ...prevV,
                          truck: newValue.UId,
                          driver: vTruckObj.Driver,
                          driverName: vTruckObj.DriverName,
                          CBM: vTruckObj.CBM,
                        }));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          slotProps={{
                            input: {
                              ...params.InputProps,
                              type: "search",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography>Driver</Typography>
                    <CmpTextFieldV1
                      xLabelText=""
                      xValue={masterData?.driverName}
                      xType={"text"} // text/number/password
                      xName={"Driver"}
                      xReadOnly={true}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        width: isMobile ? "75px" : "100px",
                        height: "35px",
                        mt: 2,
                        textTransform: "capitalize",
                      }}
                      // disabled={isEditing}
                      onClick={(e) => {
                        handleUpdate();
                      }}
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default UpdatedTruck;
